import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { DialogSystemGLPure, SimpleLoading, TooltipHLPure, ButtonHLPure, TextAreaHLPure, InputHLPure, DialogYesNoHLPure, ButtonAddHLPure } from "../../pures";
import DialogAcceptSignatureESignature from "../../pures/signature-request-detail/dialog-accept-signature-e-firma";
import DialogAcceptSignatureElectronica from "../../pures/signature-request-detail/dialog-accept-signature-electronica";
import DialogAcceptSignatureAutografaCustom from "../../pures/signature-request-detail/dialog-accept-signature-autografa-custom";
import DialogRejectSignature from "../../pures/signature-request-detail/dialog-reject-signature";
// import DialogAcceptMultiSignatureAutografaCustom from '../../pures/signature-request-detail/dialog-accept-multi-signature-autografa-custom'

import DialogEditExpirationDate from "../../pures/signature-request-detail/dialog-edit-expiration-date";
import DialogPdf from "../../pures/signature-request-detail/dialog-pdf";
import DialogResendSignatureRequest from "../../pures/dialog-resend-signature-request/dialog-resend-signature-request.pure";
import DialogReactivateSignatureRequest from "../../pures/dialog-reactivate-signature-request/dialog-reactivate-signature-request.pure";
import DialogDeleteSignaturePure from "../../pures/dialog-delete-signature/dialog-delete-signature.pure";
import GridListSigners from "../../pures/signature-request-detail/grid-list-signers";
import GridListSignatures from "../../pures/signature-request-detail/grid-list-signature";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { b64toBlob } from "./../../../validators";
import "./signature-request-detail.css";
import { NotificationPure } from "../../pures";
import autografa from "../../../assets/logos/autografa.png";
import avanzada from "../../../assets/logos/avanzada.png";
import efirma from "../../../assets/logos/efirma.png";
import {
  ConservacionMensajeImage,
  EstampadoTiempoImage,
} from "../../../assets/logos/icons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { PDFDocument } from "pdf-lib";
import OldDialogAcceptSignatureAutografaCustom from "../../pures/signature-request-detail/old-signature-autograph";
import OldDialogRejectSignature from "../../pures/signature-request-detail/old-dialog-reject-signature";
import OldDialogAcceptSignature from "../../pures/signature-request-detail/old-dialog-esignature";
import OldDilogElectronicSiganture from "../../pures/signature-request-detail/old-dialog-electronic-signature";
// import { Context } from '../../../Context';
const signatureTypesImg = {
  1: efirma,
  2: avanzada,
  3: autografa,
};

function SignatureRequestDetailView(props) {
  // const { setShowPdf, setPdf, setPdfSucess } = useContext(Context);
  const [result, setResult] = useState(null);
  const [showPdfSignatures, setShowPdfSignatures] = useState(false);
  const toggleShowPdfSignatures = () =>
    setShowPdfSignatures(!showPdfSignatures);
  const [currentUser, setCurrentUser] = useState({});
  const [signatures, setSignatures] = useState([]);
  const [currentSystem, setCurrentSystem] = useState("");
  const { isShowAutorizationModal, setIsShowAutorizationModal, showBtnSend, showBtnClassify, showReasonCancellation, cancellationReason } = props;
  let { imgSignature, setImgSignature } = props;
  const { t } = useTranslation();
  const [blobUrl, setBlobUrl] = useState("");
  const [blob, setBlob] = useState("");
  const [signRequestPDFURL, setSignRequestPDFURL] = useState('')
  const [stillSigning, setStillSigning] = useState(false)

  const autographySignImg = "data:image/png;base64," + props.signatureRequest.autographySign
  const pdf = useMemo(() => <PdfViewerAction url={blobUrl || signRequestPDFURL} isExtended={false} isSSRActive={false} />, [signRequestPDFURL, blobUrl])

  useEffect(() => {
    if (props.signRequestPDFURL && props.signRequestPDFURL !== signRequestPDFURL) {
      setSignRequestPDFURL(props.signRequestPDFURL)
    }
  }, [props.signRequestPDFURL])

  useEffect(() => {
    if (props.currentUser) {
      setCurrentUser(props.currentUser);
      let tempArr = [];
      for (let index = 0; index < props.currentUser.numSign; index++) {
        tempArr.push({ date: null, index: index + 1, page: "" });
      }
      setSignatures(tempArr);
    }
  }, [props.currentUser]);

  const createPdf = () => {
    let signatureData = signatures.map((i, j) => ({
      x: i.x,
      y: i.y,
      width: i.width,
      height: i.height,
      page: i.page,
      isMobile: true,
      fileSignImage: i.fileSignImage,
      imgSignature: i.imgSignature,
      fileName: `sign${j + 1}`,
    }));
    props.setSignatures(signatureData);
    // insertSignByCoordinates(signatureData);
  };

  useEffect(() => {
    createPdf();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signatures]);

  useEffect(() => {
    const blob = b64toBlob(props.signRequestPDF, "application/pdf");
    if (props.signRequestPDF !== "" || props.signRequestPDF !== null) {
      setBlobUrl(URL.createObjectURL(blob));
      setBlob(blob);
    }
  }, [props.signRequestPDF]);
  useEffect(() => {
    if (props?.signatureTypes?.length > 0)
      props.setCurrentType(
        props.signatureTypes.find(
          (item) => props.signRequest.signatureTypeId === item.id
        )
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signatureTypes]);
  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  const insertSignByCoordinates = async (signatureData) => {
    if (!!signatureData.find((i) => i.imgSignature)) {
      const existingPdfBytes = await fetch(
        "data:application/pdf;filename=data.pdf;base64," + props.signRequestPDF
      ).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages()
      for (let index = 0; index < signatureData.length; index++) {
        const { x, y, width, height, page, isMobile, imgSignature } =
          signatureData[index];
        if (imgSignature) {
          const fileSignImage = await fetch(imgSignature).then((res) =>
            res.arrayBuffer()
          );
          const pageToSign = page <= 0 ? pages[0] : pages[page - 1];
          const heightPage = pageToSign.getHeight();
          const pngSignImage = await pdfDoc.embedPng(fileSignImage);
          pngSignImage.scale(1);
          pageToSign.drawImage(pngSignImage, {
            x,
            y: isMobile ? y : heightPage - y - height,
            width,
            height,
          });
        }
      }
      const pdfBytes = await pdfDoc.saveAsBase64();
      let elnuevopdf =
        "data:application/pdf;filename=data.pdf;base64," + pdfBytes;
      setResult(elnuevopdf);
    }
  };

  const notificationStyle = {
    display: "flex",
    flex: 1,
    width: "95%",
    justifyContent: "flex-end",
    alignItems: "center",
  };

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    width: "auto",
    padding: "20px"
  };
  const containerTableAndHeadersStyles = {
    maxWidth: "100%",
    justifyContent: "start",
  };
  let currentSignaturetype = null;
  if (props.signatureTypes.length > 0)
    currentSignaturetype = props.signatureTypes.find(
      (item) => props.signRequest.signatureTypeId === item.id
    );

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  const isMobileResolution = useMediaQuery("(max-width: 650px)")

  // if (isTouchScreendevice()) {
  //   isMobile = true;
  // }
  const numSign = currentUser.numSign || 1;

  return (
    <div className="requestDetail">
      {props.loading ? (
        <>
          <div style={notificationStyle}>
            <NotificationPure
              notification={props.userRequestingSingError || props.userPfxError}
              type={{ style: "error", icon: true }}
              style={{}}
              onClose={() => { }}
              message={t(
                props.userRequestingSingError
                  ? "signature.request.detail.userRequestingSingError"
                  : "signature.request.detail.userPfxError"
              )}
            />
          </div>
          <SimpleLoading />
        </>
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          style={globalContainerStyles}
        >
          {/* Header H3 */}
          <div className="signature-detail-wrapper title-detail">
            <h3 className="SignatureRequestDetailView-table-title-h3">
              {t("signatureRequestDetailView2.titleSignRequest")}
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "8px",
              }}
            >
              {props?.servicesInSignsRequest?.length > 0 &&
                props.servicesInSignsRequest.map((item, index) => {
                  let serviceIcon = ConservacionMensajeImage;
                  if (
                    item.service.id ===
                    Number(
                      process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_DOCUMENT
                    )
                  )
                    serviceIcon = EstampadoTiempoImage;
                  if (
                    item.service.id ===
                    Number(
                      process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_BY_SIGNATURE
                    )
                  )
                    serviceIcon = EstampadoTiempoImage;
                  return (
                    <React.Fragment key={String(index)}>
                      <TooltipHLPure
                        titleTooltip={item.service.name}
                        positionTooltip={"top"}
                        customImg={serviceIcon}
                        styleCustomImg={"signature-detail-tooltip-img"}
                      />
                    </React.Fragment>
                  );
                })}
              {(currentSignaturetype && !props.showIconSignaturesMultiple) &&
                signatureTypesImg[currentSignaturetype?.id] && (
                  <TooltipHLPure
                    titleTooltip={"Tipo de firma"}
                    positionTooltip={"top"}
                    descriptionTooltip={`${currentSignaturetype?.name}`}
                    customImg={signatureTypesImg[currentSignaturetype?.id]}
                    styleCustomImg={"signature-detail-tooltip-img"}
                  />
                )}
              {props.showIconProofOflife && (
                <TooltipHLPure
                  titleTooltip={process.env.REACT_APP_PROOF_OF_LIFE_NAME}
                  positionTooltip={"top"}
                  customImg={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_prueba_de_vida.svg`}
                  styleCustomImg={"signature-detail-tooltip-img"}
                />
              )
              }
              {props.showIconSignaturesMultiple && (
                <TooltipHLPure
                  titleTooltip={t("signatureRequestDetailView2.tooltip.signtures.multiples.title")}
                  descriptionTooltip={t("signatureRequestDetailView2.tooltip.signtures.multiples.description")}
                  positionTooltip={"top"}
                  customImg={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/iconoFirma2.svg`}
                  styleCustomImg={"signature-detail-tooltip-img"}
                />
              )
              }
              <p className="signature-detail-status">
                {t("signatureRequestDetailView2.state")}{" "}
                <span className={`${props.signStatusColor}`}>
                  {props.signStatusName || ""}
                </span>
              </p>
            </div>
          </div>
          {/* Wrapper for the form */}
          <div className="form-detail-container">
            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
              {/* Name of sign request */}
              <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                <InputHLPure
                  labelInput={t("signatureRequestDetailView2.nameRequest")}
                  typeInput={"text"}
                  valueInput={props.signRequest.name || ""}
                  inputActive={true}
                  disabled={true}
                  styleGrid={{ marginBlock: '10px' }}
                />
              </Grid>

              {/* Description of sign request */}
              {/* <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={{ marginBottom: "10px" }}
              >
                <TextAreaHLPure
                  labelTextArea={t("signatureRequestDetailView2.descriptionRequest")}
                  valueTextData={props.signRequest.description || ""}
                  readOnly
                />
              </Grid> */}

              {/* Comments of a sign request Rejected */}
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={{ marginBottom: "20px" }}
              >
                <TextAreaHLPure
                  labelTextArea={props.isSignRequestReject === true
                    ? t("signatureRequestDetailView2.reasonRejecting")
                    : t("signatureRequestDetailView2.comments")}
                  valueTextData={props.comments}
                  readOnly
                />
              </Grid>

              {
                showReasonCancellation && (
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    style={{ marginBottom: "20px" }}
                  >
                    <TextAreaHLPure
                      labelTextArea={t("signatureRequestDetailView2.cancelllation.reason")}
                      valueTextData={cancellationReason}
                      readOnly
                    />
                  </Grid>
                )
              }

              {/* List of signers and status of signers */}
              <Grid
                className="signersList"
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={{ marginBottom: "30px" }}
              >
                <p className="SignatureRequestDetailView-form-detail-labels">
                  {t("signatureRequestDetailView2.signersList")}
                </p>
                <GridListSigners
                  {...props}
                  onPageChange={props.onPageChange}
                />
              </Grid>

              {/* Limit date to sign the sign request */}
              {props.isSignRequestPending === true ? (
                <Grid
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="text-info"
                >
                  <Grid item xs={12} lg={4} md={6} sm={12} es={12}>
                    <p className="SignatureRequestDetailView-form-detail-labels">
                      {t("signatureRequestDetailView2.limitDateToSign")}:{" "}
                      <span className="form-detail-labels-date">
                        {props.expirationDate || ""}
                      </span>
                    </p>
                  </Grid>
                  {props.signatureRequest.signRequest.signatureTypeId !==
                    3 && !isMobile ? (
                    <Grid item xs={12} lg={4} md={6} sm={12} es={12}>
                      <p className="text-processSignature">
                        {t(
                          "signatureRequestDetailView2.endProcessSignatures"
                        )}
                      </p>
                    </Grid>
                  ) : (
                    ""
                  )}
                  <Grid
                    item
                    xs={12}
                    lg={4}
                    md={6}
                    sm={12}
                    es={12}
                  >
                    {props.userCanEditExpirationDate === true ? (
                      <ButtonHLPure
                        nameBtn={t("signatureRequestDetailView2.buttonEditLimitDate")}
                        onClickBtn={props.toggleEditExpirationDate}
                      />
                    ) : null}
                  </Grid>
                </Grid>
              ) : null}
              {isMobile && props.isSignRequestPending !== true ? (
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="text-info"
                >
                  <p className="text-processSignature">
                    {t("signatureRequestDetailView2.endProcessSignatures")}
                  </p>
                  <Grid
                    style={{ marginTop: "4px" }}
                    item
                    xs={12}
                    lg={4}
                    md={6}
                    sm={12}
                    es={12}
                  >
                    {props.userCanEditExpirationDate === true && !isMobile ? (
                      <ButtonHLPure
                        nameBtn={t("signatureRequestDetailView2.buttonEditLimitDate")}
                        onClickBtn={props.toggleEditExpirationDate}
                      />
                    ) : null}
                  </Grid>
                </Grid>
              ) : null}

              {/* Rendering PDF of the sign request */}
              {props.signRequestPDF === "" ||
                props.signRequestPDF === null ? null : (
                <Fragment>
                  {isMobile ? (
                    <div className="pdf-btn">
                      <DialogPdf blobUrl={blob} />
                    </div>
                  ) : (
                    <Grid
                      className="pdf-container"
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                    >
                      {pdf}
                    </Grid>
                  )}
                </Fragment>
              )}
              <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                <div className="form-detail-group-buttons" style={isMobile ? null : { marginTop: '20px' }}>
                  <Link
                    to={
                      props.view.route === "index"
                        ? "/"
                        : `/${props.view.route}`
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <ButtonHLPure
                      nameBtn={t("signatureRequestDetailView2.buttonBack")}
                      onClickBtn={props.scrollWindow}
                    />
                  </Link>
                  {
                    props.userCanCancelSignRequest && isMobileResolution && <DialogDeleteSignaturePure
                      {...props}
                      toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
                      handleCommentsDelete={props.handleCommentsDelete}
                      deleteSignRequest={props.deleteSignRequest}
                    />
                  }
                  {
                    isMobileResolution && <Link
                      to={{
                        pathname: `/document-tracking/${props.signatureRequest.signRequest.id}`,
                        params: { dataItem: props.signatureRequest.inbox },
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <ButtonHLPure
                        nameBtn={t("signatureRequestDetailView2.buttonDocumentTracking")}
                        onClickBtn={props.scrollWindow}
                      />
                    </Link>
                  }
                  <OldDialogRejectSignature {...props} />
                  {/* Rendering PDF of the sign request */}
                  {/* {props.signRequestPDF === "" ||
                    props.signRequestPDF === null ? null : (
                    <Fragment>
                      {isMobile && isMobileResolution && (
                        <div className="pdf-btn">
                          <DialogPdf blobUrl={blob} />
                        </div>
                      )}
                    </Fragment>
                  )} */}
                  <OldDialogAcceptSignature
                    {...props}
                    setIsShowAutorizationModal={setIsShowAutorizationModal}
                    imgSignature={imgSignature}
                    setImgSignature={setImgSignature}
                    currentSignaturetype={currentSignaturetype ?? {}}
                  />
                  <OldDilogElectronicSiganture
                    {...props}
                    setIsShowAutorizationModal={setIsShowAutorizationModal}
                    imgSignature={imgSignature}
                    setImgSignature={setImgSignature}
                    currentSignaturetype={currentSignaturetype ?? {}}
                  />
                  {//aQUI? 
                  }
                  <OldDialogAcceptSignatureAutografaCustom
                    {...props}
                    signatures={signatures}
                    currentUser={currentUser}
                    setIsShowAutorizationModal={
                      setIsShowAutorizationModal
                    }
                    imgSignature={imgSignature}
                    setImgSignature={setImgSignature}
                    currentSignaturetype={currentSignaturetype ?? {}}
                    result={result}
                    setSignatures={setSignatures}
                    setAllSignatures={props.setSignatures}
                    insertSignByCoordinates={insertSignByCoordinates}
                    toggleLoadingRequesting={props.toggleLoadingRequesting}

                    autographySign={autographySignImg}
                  />
                  <DialogResendSignatureRequest
                    {...props}
                    toggleDialogResendSignatureRequest={
                      props.toggleDialogResendSignatureRequest
                    }
                    onResendSignatureRequest={
                      props.onResendSignatureRequest
                    }
                  />
                  <DialogReactivateSignatureRequest
                    {...props}
                    toggleDialogReactivateSignatureRequest={
                      props.toggleDialogReactivateSignatureRequest
                    }
                    onReactivateSignatureRequest={
                      props.onReactivateSignatureRequest
                    }
                  />
                  <DialogSystemGLPure {...props} />
                  {props?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && props.idPrecharge === null && (props.idVault === 14 || props.idVault === 15) && showBtnSend ? (
                    <React.Fragment>
                      <ButtonHLPure
                        nameBtn={t("btn.send.boveda")}
                        onClickBtn={() => {
                          props.sendToDigitalVault(props.signRequest.id);
                        }}
                      />
                    </React.Fragment>
                  ) : null}
                  {props?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && props.idPrecharge !== null && props.idPrecharge != undefined && showBtnClassify ? (
                    <Link to={{ pathname: "/digital-vault-grc", state: { idPrecarga: props.idPrecharge } }}>
                      <React.Fragment>
                        <ButtonHLPure
                          nameBtn={t("btn.clasify.boveda")}
                        />
                      </React.Fragment>
                    </Link>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </div>
        </Container >
      )
      }
      <DialogEditExpirationDate
        {...props}
        toggleEditExpirationDate={props.toggleEditExpirationDate}
        onUpdateExpirationDate={props.onUpdateExpirationDate}
      />
      {
        isShowAutorizationModal && (
          <DialogYesNoHLPure
            titleDialog={t("button.authorizeApplication")}
            textBtnCancel={t("button.cancel")}
            cancel={() => setIsShowAutorizationModal()}
            saveBtn={t("button.authorize")}
            handleSubmit={() => props.authorize()}
            loadingComponent={props.showLoadingRequesting}
            saveError={props.showErrorRequesting}
          >
            <div style={{ marginBlock: "30px" }}>
              <p className="SignatureRequestDetailView-dialog-authorization-subtitle">
                {t("signatureRequestDetailView2.modalquestion")}
              </p>
            </div>
          </DialogYesNoHLPure>
        )
      }
      <DialogSystemGLPure
        messageError={props.message}
        showLoadingRequesting={props.showLoadingRequesting}
        showCompletedRequesting={props.showCompletedRequesting}
        showErrorRequesting={props.showErrorRequesting}
        isWarnign={props.isWarnign}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        handleWarning={props.handleWarning}
        message={props.message}
      />
    </div >
  );
}

export { SignatureRequestDetailView as default };
